import React, { useCallback, useEffect, useState } from "react";
import { Button, Input, Modal, Select, Slider } from "antd";

import Title from "antd/es/typography/Title";
import {
  COST_SAVINGS_MARKS,
  FILTER_INITIAL_OBJECT,
} from "../../screens/Rankings/RankingsUtils";
import { RankingAPI } from "../../API/RankingAPI";
import { useFlightModel } from "../../contexts/FlightModelContext";

export const RankingFilters = ({
  open,
  setOpen,
  setListData,
  setDragableSatate,
  setFilterStatus,
  defualtData,
  filteredValues,
  setFilteredvalues,
  serachInput,
  setTotalRecords,
  setPage,
  page,
  pageSize,
  messageToast,
}) => {
  const { selectedFlightModel, refreshFlightModels } = useFlightModel();
  const [inputElements, setInputElements] = useState(FILTER_INITIAL_OBJECT);
  const [spinning, setSpinning] = useState(false);
  const [filterOptions, setFilterOptions] = useState({
    spec_types: [],
    statuses: [],
    task_types: [],
    mntc_checks: [],
    mntc_check_packages: [],
    mntc_check_intervals: [],
    mntc_check_package_intervals: [],
  });
 
  // useEffect(() => {
    
  //   const queryParams = {
  //     params: {
  //       flight_model: localStorage.getItem("flight_model"),
  //     },
  //   };
  //   RankingAPI.getFilterFieldOptions(queryParams)
  //     .then((res) => {
  //       if (res?.data) {
  //         setFilterOptions({
  //           spec_types: res.data.spec_types || [],
  //           statuses: res.data.statuses || [],
  //           task_types: res.data.task_types || [],
  //           mntc_checks: res.data.mntc_checks || [],
  //           mntc_check_packages: res.data.mntc_check_packages || [],
  //           mntc_check_intervals: res.data.mntc_check_intervals || [],
  //           mntc_check_package_intervals:
  //             res.data.mntc_check_package_intervals || [],
  //         });
  //       }
  //     })
  //     .catch(() => {});
  // }, []);
const getFilterOptions = useCallback(async () => {
  try {
    let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }

    const res = await RankingAPI.getFilterFieldOptions({
      params: {
        flight_model: flightModelToUse, // ✅ use context, NOT localStorage
      },
    });

    if (res?.data) {
      setFilterOptions({
        spec_types: res.data.spec_types || [],
        statuses: res.data.statuses || [],
        task_types: res.data.task_types || [],
        mntc_checks: res.data.mntc_checks || [],
        mntc_check_packages: res.data.mntc_check_packages || [],
        mntc_check_intervals: res.data.mntc_check_intervals || [],
        mntc_check_package_intervals:
          res.data.mntc_check_package_intervals || [],
      });
    }
  } catch (error) {
    messageToast("error", "Internal Server Error");
  }
}, [selectedFlightModel, refreshFlightModels, messageToast]);
useEffect(() => {
  getFilterOptions();
}, [getFilterOptions]);
  async function applyFun() {
    const hasFilter =
      inputElements?.cat?.trim() !== "" ||
      inputElements?.specType?.trim() !== "" ||
      inputElements?.status?.length > 0 ||
      inputElements?.task?.length > 0 ||
      inputElements.yieldValueFrom !== 0 ||
      inputElements.yieldValueTo !== 100 ||
      inputElements?.maintenanceCheck?.trim() !== "" ||
      inputElements?.maintenanceCheckPackage?.trim() !== "" ||
      inputElements?.maintenanceCheckInterval?.trim() !== "" ||
      inputElements?.maintenanceCheckPackageInterval?.trim() !== "";
 let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }

    const queryParams = {
      params: {
        flight_model:flightModelToUse,
        //  localStorage.getItem("flight_model"),
        page: 1,
        page_size: pageSize,
        spec_type: inputElements.specType,
        status: inputElements.status.map((ele) => ele.trim()).join(","),
        mntc_check: inputElements.maintenanceCheck,
        mntc_check_package: inputElements.maintenanceCheckPackage,
        mntc_check_interval: inputElements.maintenanceCheckInterval,
        mntc_check_package_interval:
          inputElements.maintenanceCheckPackageInterval,
        yield_min: inputElements.yieldValueFrom,
        yield_max: inputElements.yieldValueTo,
        fec: inputElements.cat,
        task_type: inputElements.task.map((ele) => ele.trim()).join(","),
        search: serachInput.trim(),
      },
    };

    try {
      setSpinning(true);
      const response = await RankingAPI.getRannkList(queryParams);
      if (response.data.status === true) {
        setTotalRecords(response.data.total);
        setListData(response?.data?.data || []);
        setPage(1);

        setFilteredvalues({
          cat: inputElements.cat,
          status: inputElements.status,
          task: inputElements.task,
          specType: inputElements.specType,
          yieldValueFrom: inputElements.yieldValueFrom,
          yieldValueTo: inputElements.yieldValueTo,
          maintenanceCheck: inputElements.maintenanceCheck,
          maintenanceCheckPackage: inputElements.maintenanceCheckPackage,
          maintenanceCheckInterval: inputElements.maintenanceCheckInterval,
          maintenanceCheckPackageInterval:
            inputElements.maintenanceCheckPackageInterval,
        });

        if (!hasFilter) {
          setDragableSatate(true);
          setFilterStatus(false);
          setOpen(false);
          return;
        }

        setDragableSatate(false);
        setFilterStatus(true);
        setOpen(false);
      } else {
        messageToast("error", response.statusText || "Failed to apply filters");
      }
    } catch (error) {
      messageToast("error", error?.message || "Failed to apply filters");
    } finally {
      setSpinning(false);
    }
  }
  const handleFromChange = (e) => {
    const value = Number(e.target.value);
    setInputElements((prev) => ({
      ...prev,
      yieldValueFrom: value,
    }));
  };

  const handleToChange = (e) => {
    const value = Number(e.target.value);
    setInputElements((prev) => ({
      ...prev,
      yieldValueTo: value,
    }));
  };

  const handleSliderChange = (value) => {
    setInputElements((prev) => ({
      ...prev,
      yieldValueFrom: value[0],
      yieldValueTo: value[1],
    }));
  };

  async function cancelFun() {
    try {
      setSpinning(true);
       let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }

      const queryParams = {
        params: {
          flight_model:flightModelToUse,
          //  localStorage.getItem("flight_model"),
          page: 1,
          page_size: pageSize,
          spec_type: null,
          status: [],
          mntc_check: null,
          mntc_check_package: null,
          mntc_check_interval: null,
          mntc_check_package_interval: null,
          yield_min: null,
          yield_max: null,
          fec: null,
          task_type: [],
          search: serachInput.trim(),
        },
      };
      const res = await RankingAPI.getRannkList(queryParams);

      if (res.data.status === true) {
        setListData(res?.data?.data || []);
        setTotalRecords(res.data.total);
        setPage(1);

        if (!serachInput.trim()) {
          setDragableSatate(true);
        } else {
          setDragableSatate(false);
        }
        setInputElements(FILTER_INITIAL_OBJECT);
        setOpen(false);
        setFilterStatus(false);
        setFilteredvalues({
          cat: "",
          status: [],
          task: [],
          specType: "",
          yieldValueFrom: 0,
          yieldValueTo: 100,
          maintenanceCheck: "",
          maintenanceCheckPackage: "",
          maintenanceCheckInterval: "",
          maintenanceCheckPackageInterval: "",
        });
      } else {
        messageToast("error", res.statusText || "Failed to clear filters");
      }
    } catch (error) {
      messageToast("error", error?.message || "Failed to clear filters");
    } finally {
      setSpinning(false);
    }
  }

  function backFun() {
    setInputElements(FILTER_INITIAL_OBJECT);
    setOpen(false);
  }

  useEffect(() => {
    if (open) {
      setInputElements({
        cat: filteredValues.cat,
        status: filteredValues.status,
        task: filteredValues.task,
        specType: filteredValues.specType,
        yieldValueFrom: filteredValues.yieldValueFrom,
        yieldValueTo: filteredValues.yieldValueTo,
        maintenanceCheck: filteredValues.maintenanceCheck,
        maintenanceCheckPackage: filteredValues.maintenanceCheckPackage,
        maintenanceCheckInterval: filteredValues.maintenanceCheckInterval,
        maintenanceCheckPackageInterval:
          filteredValues.maintenanceCheckPackageInterval,
      });
    }
  }, [open, filteredValues]);

  return (
    <Modal
      open={open}
      width="900px"
      okText="Apply"
      cancelText="Clear All"
      onCancel={() => backFun()}
      onOk={applyFun}
      footer={[
        <Button key="back" type="text" onClick={backFun}>
          Cancel
        </Button>,
        <Button
          key="clear"
          type="default"
          onClick={cancelFun}
          loading={spinning}
        >
          Clear All
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={applyFun}
          loading={spinning}
        >
          Apply
        </Button>,
      ]}
    >
      <div style={{ padding: "10px" }}>
        <div
          style={{ marginBottom: "20px", borderBottom: "solid 1px #80808047" }}
        >
          <Title level={5}>Filters</Title>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "15px",
          }}
        >
          <div>
            <label>FEC</label>
            <Input
              value={inputElements.cat}
              onChange={(e) => {
                const value = e.target.value.trimStart();
                setInputElements((prev) => ({
                  ...prev,
                  cat: value,
                }));
              }}
            />
          </div>

          <div>
            <label>Status</label>
            <Select
              mode="multiple"
              allowClear
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.status}
              onChange={(e) => {
                setInputElements((prev) => ({
                  ...prev,
                  status: e,
                }));
              }}
              options={filterOptions.statuses.map((s) => ({
                value: s,
                label: s,
              }))}
            />
          </div>

          <div>
            <label>Task Type</label>
            <Select
              mode="multiple"
              allowClear
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.task}
              onChange={(e) => {
                setInputElements((prev) => ({
                  ...prev,
                  task: e,
                }));
              }}
              options={filterOptions.task_types.map((ele) => ({
                value: ele,
                label: ele,
              }))}
            />
          </div>

          <div>
            <label>Maintenance Check</label>
            <Select
              // allowClear
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.maintenanceCheck}
              onChange={(value) => {
                setInputElements((prev) => ({
                  ...prev,
                  maintenanceCheck: value,
                }));
              }}
              options={filterOptions.mntc_checks.map((v) => ({
                value: v,
                label: v,
              }))}
            />
          </div>

          <div>
            <label>Maintenance Check Package</label>
            <Select
              // allowClear
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.maintenanceCheckPackage}
              onChange={(value) => {
                setInputElements((prev) => ({
                  ...prev,
                  maintenanceCheckPackage: value,
                }));
              }}
              options={filterOptions.mntc_check_packages.map((v) => ({
                value: v,
                label: v,
              }))}
            />
          </div>

          <div>
            <label>Maintenance Check Interval</label>
            <Select
              // allowClear
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.maintenanceCheckInterval}
              onChange={(value) => {
                setInputElements((prev) => ({
                  ...prev,
                  maintenanceCheckInterval: value,
                }));
              }}
              options={filterOptions.mntc_check_intervals.map((v) => ({
                value: v,
                label: v,
              }))}
            />
          </div>

          <div>
            <label>Maintenance Check Package Interval</label>
            <Select
              // allowClear
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.maintenanceCheckPackageInterval}
              onChange={(value) => {
                setInputElements((prev) => ({
                  ...prev,
                  maintenanceCheckPackageInterval: value,
                }));
              }}
              options={filterOptions.mntc_check_package_intervals.map((v) => ({
                value: v,
                label: v,
              }))}
            />
          </div>

          <div>
            <label>Spec Type</label>
            <Select
              // mode="multiple"
              allowClear
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              value={inputElements.specType}
              onChange={(e) => {
                setInputElements((prev) => ({
                  ...prev,
                  specType: e,
                }));
              }}
              options={filterOptions.spec_types.map((v) => ({
                value: v,
                label: v,
              }))}
            />
          </div>
          <div>
            <label>Yield Percentage</label>

            {/* Inputs */}
            <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
              <Input
                value={inputElements.yieldValueFrom}
                onChange={handleFromChange}
                style={{ width: "80px" }}
              />

              <Input
                value={inputElements.yieldValueTo}
                onChange={handleToChange}
                style={{ width: "80px" }}
              />
            </div>

            {/* Slider */}
            <Slider
              range
              min={0}
              max={100}
              marks={COST_SAVINGS_MARKS}
              value={[inputElements.yieldValueFrom, inputElements.yieldValueTo]}
              onChange={handleSliderChange}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
